import { Helmet, HelmetData } from "react-helmet-async";
import {
  AI_BG_NEW,
  // Profile_man,
  // Profile_woman,
  // Upcoming_Events,
} from "../../../images";
import { useRef, useState, useEffect } from "react";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import SearchOutlined from "@mui/icons-material/SearchOutlined";
import { eventsData, upcomingEvents } from "./constant";
import { NewFooter } from "../../newFooter";
import useIntersectionObserver from "../../../utils/useIntersectionObserver";
const helmetData = new HelmetData({});

function CountdownTimer({ targetDate }) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculate = () => {
      const diff = new Date(targetDate) - new Date();
      if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      return {
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      };
    };

    setTimeLeft(calculate());
    const interval = setInterval(() => setTimeLeft(calculate()), 1000);
    return () => clearInterval(interval);
  }, [targetDate]);

  const pad = (n) => String(n).padStart(2, "0");

  return (
    <div className="flex items-center justify-center md:justify-start space-x-4 text-black mt-2 md:mt-4 w-full">
      {[
        { value: pad(timeLeft.days), label: "Days" },
        { value: pad(timeLeft.hours), label: "Hours" },
        { value: pad(timeLeft.minutes), label: "Minutes" },
        { value: pad(timeLeft.seconds), label: "Seconds" },
      ].map((item, idx) => (
        <div key={item.label} className="flex items-center md:gap-4">
          <div className="flex flex-col items-center bg-[#E9F8FF] py-2 px-2 md:px-3 rounded-xl">
            <span className="text-[32px] font-semibold">{item.value}</span>
            <span className="text-xs font-light">{item.label}</span>
          </div>
          {idx < 3 && <span className="text-3xl font-bold">:</span>}
        </div>
      ))}
    </div>
  );
}

export default function Events() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [length, setLength] = useState(6);

  const targetRef = useRef(null);

  useIntersectionObserver({ targetRef });

  const totalSlides = 1;

  const goToPrevious = () => {
    setCurrentIndex(currentIndex === 0 ? totalSlides - 1 : currentIndex - 1);
  };

  const goToNext = () => {
    setCurrentIndex(currentIndex === totalSlides - 1 ? 0 : currentIndex + 1);
  };

  const handleTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      goToNext();
    } else if (isRightSwipe) {
      goToPrevious();
    }
  };

  function loadMore() {
    setLength((prev) => {
      const current = prev + 6;
      return current > eventsData.length ? eventsData.length : current;
    });
  }

  return (
    <>
      <Helmet helmetData={helmetData}>
        <title>
          Events &amp; Webinars | AI Events Africa | Analytics Intelligence
          Africa
        </title>
        <link
          rel="canonical"
          href="https://africa.analyticsintelligence.com/events-and-webinars"
        />
        <meta
          name="description"
          content="Join Analytics Intelligence Africa at industry events, webinars, and executive roundtables advancing the conversation on AI in analytics across Africa. Connect, learn, and shape the future of enterprise AI."
        />
        <meta
          name="keywords"
          content="Analytics Intelligence Africa events, AI events Africa, AI webinars Africa, enterprise AI events Africa, AI roundtables Africa, data analytics events Africa, AI conference Africa, AI Nigeria events, AI Ghana events, AI Kenya events, AI summit Africa"
        />
        <meta
          property="og:title"
          content="Events & Webinars | AI Events Africa | Analytics Intelligence Africa"
        />
        <meta
          property="og:description"
          content="Join Analytics Intelligence Africa at industry events and webinars advancing enterprise AI across Africa."
        />
        <meta
          property="og:url"
          content="https://africa.analyticsintelligence.com/events-and-webinars"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://africa.analyticsintelligence.com/favicon.png"
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:title"
          content="Events & Webinars | AI Events Africa | Analytics Intelligence Africa"
        />
        <meta
          name="twitter:description"
          content="Join Analytics Intelligence Africa at industry events and webinars advancing enterprise AI across Africa."
        />
        <meta
          name="twitter:image"
          content="https://africa.analyticsintelligence.com/favicon.png"
        />
      </Helmet>

      <main>
        <section
          style={{
            backgroundImage: `url("${AI_BG_NEW}")`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          className="min-h-[65vh] flex items-center"
          ref={targetRef}
        >
          <div className="container mx-auto w-full h-full pt-[126px] md:pt-[96px] pb-[0px]">
            <div className="flex flex-col items-center gap-6 md:gap-4">
              <h2 className="text-[36px] md:text-[48px] text-center md:text-left font-extrabold leading-[1.3] md:leading-[54px] text-white">
                Events & Webinars
              </h2>
              <div>
                <p className="text-sm md:text-lg text-center font-medium text-[#E3E3E3] leading-5 max-w-[1200px]">
                  We host and participate in industry events, webinars, and
                  executive roundtables to advance the conversation on AI in
                  analytics. From hands-on demonstrations of our products to
                  high-level discussions with industry leaders, our events are a
                  chance to connect, learn, and shape the future of enterprise
                  AI.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-white relative py-[80px] md:py-[100px] overflow-hidden">
          <div className="container relative w-full mx-auto">
            <div className="h-[300px] w-[300px] xl:h-[350px] xl:w-[350px] bg-[#7AA8FF] blur-[180px] absolute top-0 -right-[70%] md:-right-[45%] lg:-right-[25%]"></div>
            <h2 className="text-[28px] md:text-[32px] text-center font-bold leading-[1.3] md:leading-[54px] text-[#2F4171]">
              Upcoming Events
            </h2>

            {/* Slider Container */}
            <div className="overflow-hidden rounded-lg w-[100%] md:w-[80%] mx-auto">
              <div
                className="flex transition-transform duration-300 ease-in-out"
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
              >
                {upcomingEvents.map((event, index) => (
                  <div
                    key={index}
                    className="flex flex-col md:flex-row items-center justify-center gap-16 md:mx-auto w-full flex-shrink-0 pt-6 md:py-16"
                  >
                    <div className="flex-1 h-full">
                      <img
                        src={event.image}
                        alt={event.title}
                        className="w-full h-full object-contain rounded-lg"
                      />
                    </div>

                    <div className="flex-1 flex flex-col items-center md:items-start justify-center h-full gap-4 w-full">
                      <div className="space-y-0.5">
                        <h2 className="text-black font-bold text-[24px] md:text-[32px] text-left">
                          {event.title}
                        </h2>
                      </div>
                      <div className="w-full">
                        <div className="flex justify-between">
                          <div className="flex gap-1 items-center">
                            <svg
                              width="18"
                              height="20"
                              viewBox="0 0 18 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M16.5 1.5H14.25V0.75C14.25 0.551088 14.171 0.360322 14.0303 0.21967C13.8897 0.0790176 13.6989 0 13.5 0C13.3011 0 13.1103 0.0790176 12.9697 0.21967C12.829 0.360322 12.75 0.551088 12.75 0.75V1.5H5.25V0.75C5.25 0.551088 5.17098 0.360322 5.03033 0.21967C4.88968 0.0790176 4.69891 0 4.5 0C4.30109 0 4.11032 0.0790176 3.96967 0.21967C3.82902 0.360322 3.75 0.551088 3.75 0.75V1.5H1.5C1.10218 1.5 0.720644 1.65804 0.43934 1.93934C0.158035 2.22064 0 2.60218 0 3V18C0 18.3978 0.158035 18.7794 0.43934 19.0607C0.720644 19.342 1.10218 19.5 1.5 19.5H16.5C16.8978 19.5 17.2794 19.342 17.5607 19.0607C17.842 18.7794 18 18.3978 18 18V3C18 2.60218 17.842 2.22064 17.5607 1.93934C17.2794 1.65804 16.8978 1.5 16.5 1.5ZM3.75 3V3.75C3.75 3.94891 3.82902 4.13968 3.96967 4.28033C4.11032 4.42098 4.30109 4.5 4.5 4.5C4.69891 4.5 4.88968 4.42098 5.03033 4.28033C5.17098 4.13968 5.25 3.94891 5.25 3.75V3H12.75V3.75C12.75 3.94891 12.829 4.13968 12.9697 4.28033C13.1103 4.42098 13.3011 4.5 13.5 4.5C13.6989 4.5 13.8897 4.42098 14.0303 4.28033C14.171 4.13968 14.25 3.94891 14.25 3.75V3H16.5V6H1.5V3H3.75ZM16.5 18H1.5V7.5H16.5V18Z"
                                fill="#282828"
                              />
                            </svg>

                            <p className="text-black text-sm">
                              {new Intl.DateTimeFormat("en-GB", {
                                weekday: "long",
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                              })
                                .format(new Date(event.date))
                                .replace(/^(\w+)\s/, "$1, ")}
                            </p>
                          </div>
                          {/* <div className="flex gap-1 items-center">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM12 20.25C10.3683 20.25 8.77326 19.7661 7.41655 18.8596C6.05984 17.9531 5.00242 16.6646 4.378 15.1571C3.75358 13.6496 3.5902 11.9908 3.90853 10.3905C4.22685 8.79016 5.01259 7.32015 6.16637 6.16637C7.32016 5.01259 8.79017 4.22685 10.3905 3.90852C11.9909 3.59019 13.6497 3.75357 15.1571 4.37799C16.6646 5.00242 17.9531 6.05984 18.8596 7.41655C19.7661 8.77325 20.25 10.3683 20.25 12C20.2475 14.1873 19.3775 16.2843 17.8309 17.8309C16.2843 19.3775 14.1873 20.2475 12 20.25ZM18 12C18 12.1989 17.921 12.3897 17.7803 12.5303C17.6397 12.671 17.4489 12.75 17.25 12.75H12C11.8011 12.75 11.6103 12.671 11.4697 12.5303C11.329 12.3897 11.25 12.1989 11.25 12V6.75C11.25 6.55109 11.329 6.36032 11.4697 6.21967C11.6103 6.07902 11.8011 6 12 6C12.1989 6 12.3897 6.07902 12.5303 6.21967C12.671 6.36032 12.75 6.55109 12.75 6.75V11.25H17.25C17.4489 11.25 17.6397 11.329 17.7803 11.4697C17.921 11.6103 18 11.8011 18 12Z"
                              fill="#282828"
                            />
                          </svg>

                          <p className="text-black text-sm">
                            {new Intl.DateTimeFormat("en-GB", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            }).format(new Date(event.date))}
                          </p>
                        </div> */}
                        </div>
                      </div>
                      <div className="flex w-full gap-4 items-start md:items-center">
                        <h4 className="text-base md:text-xl text-[#2F4171] font-semibold">
                          Guest Speakers
                        </h4>
                        <div className="flex gap-3">
                          {event.speakers.map((speaker, idx) => (
                            <div
                              key={idx}
                              className="overflow-hidden w-6 h-6 rounded-full border-2 border-black"
                            >
                              <img
                                src={speaker.avatar}
                                alt={speaker.name}
                                className="w-full h-full object-cover"
                              />
                            </div>
                          ))}
                        </div>
                      </div>

                      <CountdownTimer targetDate={event.date} />

                      <a
                        href={event.watchUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-8"
                      >
                        <button className="bg-[#0073FF] text-white px-12 py-4 rounded-2xl">
                          Register Now
                        </button>
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Dot Indicators */}
            <div className="flex justify-center gap-2 mt-6">
              {upcomingEvents.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    currentIndex === index
                      ? "bg-[#0073FF] scale-110"
                      : "bg-gray-400"
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>

            {/* Navigation Buttons */}
            <button
              onClick={goToPrevious}
              className="absolute left-0 md:left-2 top-10 md:top-1/2 -translate-y-1/2 text-gray-800 rounded-full p-2 shadow-lg transition-all duration-200 hidden lg:block"
              aria-label="Previous slide"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.9974 29.3332C23.3612 29.3332 29.3307 23.3636 29.3307 15.9998C29.3307 8.63604 23.3612 2.6665 15.9974 2.6665C8.6336 2.6665 2.66406 8.63604 2.66406 15.9998C2.66406 23.3636 8.6336 29.3332 15.9974 29.3332Z"
                  stroke="#0073FF"
                  stroke-width="1.5"
                />
                <path
                  d="M18 21.3332C18 21.3332 14 17.4052 14 15.9998C14 14.5944 18 10.6665 18 10.6665"
                  stroke="#0073FF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            <button
              onClick={goToNext}
              className="absolute right-0 md:right-2 top-10 md:top-1/2 -translate-y-1/2 text-gray-800 rounded-full p-2 shadow-lg transition-all duration-200 hidden lg:block"
              aria-label="Next slide"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.0026 29.3332C8.63881 29.3332 2.66927 23.3636 2.66927 15.9998C2.66927 8.63604 8.63881 2.6665 16.0026 2.6665C23.3664 2.6665 29.3359 8.63604 29.3359 15.9998C29.3359 23.3636 23.3664 29.3332 16.0026 29.3332Z"
                  stroke="#0073FF"
                  stroke-width="1.5"
                />
                <path
                  d="M14 21.3332C14 21.3332 18 17.4052 18 15.9998C18 14.5944 14 10.6665 14 10.6665"
                  stroke="#0073FF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </section>

        <section className="bg-white relative pt-[48] pb-[96px] overflow-hidden">
          <div className="h-[300px] w-[300px] xl:h-[350px] xl:w-[350px] bg-[#7AA8FF] blur-[180px] absolute bottom-0 -right-[70%] md:-right-[45%] lg:-right-[15%]"></div>
          <div className="container relative flex flex-col items-center gap-11">
            <div className="flex flex-col items-center gap-3">
              <h2 className="text-[28px] md:text-[32px] text-center font-bold leading-[1.3] md:leading-[54px] text-black">
                Watch Past Events
              </h2>

              <div className="relative w-[380px] px-6 md:px-0">
                <div className="absolute left-[34px] md:left-[20px] top-2/4 -translate-y-2/4 text-[#888]">
                  <SearchOutlined fontSize="medium" className="text-black" />
                </div>
                <input
                  type="text"
                  placeholder="Search..."
                  className="w-full py-3 pb-2 pl-12 border text-base bg-[#FFFFFF33] border-[#EDF9FF] outline-none rounded-full text-black placeholder:text-black"
                />
              </div>
            </div>

            <div className="w-full flex gap-[30px] justify-between flex-wrap">
              {eventsData.slice(0, length).map((event) => (
                <div
                  className="lg:w-[33%] md:w-[48%] max-w-[400px] w-full mx-auto flex flex-col gap-4 p-6 rounded-xl bg-[#FFFFFF0F] flex-shrink-0"
                  key={event.id}
                >
                  <div>
                    <img
                      src={event.image}
                      alt="blog"
                      className="object-cover h-[200px] w-full rounded-lg"
                    />
                  </div>
                  <div>
                    <h4 className="text-base md:text-lg font-bold text-black leading-[100%]">
                      {event.title}
                    </h4>
                  </div>

                  <div className="flex justify-between">
                    <div className="flex gap-1">
                      <CalendarTodayOutlinedIcon
                        fontSize="small"
                        className="text-black"
                      />
                      <p className="text-black text-sm">
                        {new Intl.DateTimeFormat("en-GB", {
                          weekday: "long",
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        })
                          .format(new Date(event.date))
                          .replace(/^(\w+)\s/, "$1, ")}
                      </p>
                    </div>
                    <div className="flex gap-1">
                      <AccessTimeOutlinedIcon
                        fontSize="small"
                        className="text-black"
                      />
                      <p className="text-black text-sm">
                        {new Intl.DateTimeFormat("en-GB", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: false, // ensures 24-hour format
                        }).format(new Date(event.date))}
                      </p>
                    </div>
                  </div>

                  <div className="flex justify-between">
                    <div className="flex gap-2">
                      {event.speakers.map((item, idx) => (
                        <div className="overflow-hidden w-6 h-6 rounded-full border-2 border-black">
                          <img
                            src={item.avatar}
                            key={idx}
                            alt="avatar"
                            className="object-cover"
                          />
                        </div>
                      ))}
                    </div>

                    <a href={event.watchUrl} target="_blank" rel="noreferrer">
                      <button className="text-sm font-semibold py-1.5 px-4 text- text-center bg-[#0073FF] hover:bg-[#0073FF]/70 text-white rounded-[100px] gap-2 transition-colors ease-in duration-300">
                        Watch Now
                      </button>
                    </a>
                  </div>
                </div>
              ))}
            </div>

            {length < eventsData.length && (
              <button
                className="text-sm md:text-base font-semibold py-3 w-[170px] text-center bg-poppingBlue hover:bg-poppingBlue/70 text-white rounded-[100px] gap-2 transition-colors ease-in duration-300"
                onClick={loadMore}
              >
                Load More
              </button>
            )}
          </div>
        </section>

        <NewFooter />
      </main>
    </>
  );
}
